import { GenericOperationState } from '@repo/core'
import { Device } from '@repo/user-types'
import { RootState } from '../../store/types'

export const devicesDataSelectorConfig = {
  devicesDataSelector: {
    getRootPath: function (state: RootState): GenericOperationState<Device[] | null> {
      return state.users.devices
    },
  },
}
